module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "olst-tooltip"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayed),
      expression: "isDisplayed"
    }],
    staticClass: "tooltip-container",
    attrs: {
      "transition": "tooltip"
    }
  }, [_c('div', {
    staticClass: "tooltip-header",
    domProps: {
      "textContent": _vm._s(_vm.header)
    }
  }), _c('div', {
    staticClass: "tooltip-image-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]), _c('div', {
    staticClass: "tooltip-footer",
    domProps: {
      "textContent": _vm._s(_vm.footer)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21778e5c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/tooltip/TooltipWithImage.vue
// module id = 336
// module chunks = 1